// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1-NQL","header":"styles_header__3OmKz","url":"styles_url__2M8l1","method":"styles_method__3-wEh"};